<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("product module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_product"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_product">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <!-- <div class="box mt-0">
      <div class="columns">
        <div class="column is-5">
          <h1 class="title is-4">{{ $t("custom product attributes") }}</h1>
        </div>
        <div class="column is-7">
          <p class="buttons is-pulled-right">
            <button class="button is-secondary is-rounded" @click="create">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>{{ $t("add") }}</span>
            </button>
          </p>
        </div>
      </div>
      <div class="table-container" ref="tc">
        <table
          class="table is-striped is-hoverable"
          ref="table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t("attribute") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(custom_attribute, pidx) in meta.custom_attributes"
              :key="pidx"
            >
              <td>
                {{ custom_attribute.name }}
              </td>
              <td>
                <p class="buttons">
                  <a
                    class="button"
                    :data-tooltip="$t('configure')"
                    @click="configure_attribute(custom_attribute)"
                  >
                    <span class="icon has-text-info">
                      <i class="fa fa-cogs"></i>
                    </span>
                  </a>
                  <a
                    class="button"
                    :data-tooltip="$t('delete')"
                    @click="meta.custom_attributes.splice(pidx, 1)"
                  >
                    <span class="icon has-text-danger">
                      <i class="fa fa-trash"></i>
                    </span>
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>
    </div> -->

    <div class="container">
      <categories-datatable ref="categories_datatable" />
    </div>

    <div class="container mt-5">
      <meassurements-datatable ref="meassurements_datatable" />
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <attribute-modal ref="attribute_modal" />
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";
import { v4 } from "uuid";
import AttributeModal from "./attribute_modal/Index.vue";
import CategoriesDatatable from "./categories_datatable/Index.vue";
import MeassurementsDatatable from "./meassurements_datatable/Index.vue";

export default {
  name: "ProductSettings",
  components: {
    GenericDropdown,
    AttributeModal,
    CategoriesDatatable,
    MeassurementsDatatable,
  },
  data() {
    return {
      meta: {
        custom_attributes: [],
      },
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    // add_provider() {
    //   let v = this;
    //   v.meta.providers.push({ name: "" });
    // },
    // configure_provider(provider) {
    //   let v = this;
    //   v.$refs.provider_modal.show_modal(provider);
    // },
    provider_configured(data) {
      console.log("provider_configured", data);
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
    create() {
      let v = this;
      v.meta.custom_attributes.push({
        uuid: v4(),
        name: v.$t("new attribute"),
      });
    },
    configure_attribute(attribute) {
      let v = this;
      v.$refs.attribute_modal.show_modal(attribute);
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) {
          v.meta = conf;
          if (!v.meta.custom_attributes) v.meta.custom_attributes = [];
        }
        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
